module.exports = __webpack_public_path__ + "img/kids2.png";